import * as React from "react";
import { MiniLiveOutrightDetails } from "../MiniLiveOutrightDetails";
import { MarketsWrapLiveOutright } from "../MarketsWrapLiveOutright";
export class MiniLiveOutright extends React.Component {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this */
    constructor(props) {
        super(props);
        this.componentPrefix = "mini-outright";
    }
    render() {
        const isSelected = this.props.event.isSelected
            ? `rj-ev-list__${this.componentPrefix}--selected`
            : "";
        return (React.createElement("div", { className: `rj-ev-list__${this.componentPrefix} ${isSelected}`, "data-uat": `div-ev-list-${this.componentPrefix}` },
            React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__inner`, "data-uat": `div-ev-list-${this.componentPrefix}-inner` },
                React.createElement(MiniLiveOutrightDetails, { details: this.props, componentPrefix: this.componentPrefix }),
                this.props.showOddBtns &&
                    React.createElement(MarketsWrapLiveOutright, { details: this.props, componentPrefix: this.componentPrefix }))));
    }
}
//# sourceMappingURL=MiniLiveOutright.js.map